/**
 * Generated runtime TestId mirror for frontend/src/pages/RestrictionRuleViolations.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RestrictionRuleViolationsTestIds = {
  colDetectedAt: "col-detected-at",
  colIdentity: "col-identity",
  colResolvedAt: "col-resolved-at",
  colViolatingProfile: "col-violating-profile",
  emptyStateViolations: "empty-state-violations",
  restrictionRuleViolations: "restriction-rule-violations",
  badgeOpen: (v_id: string) => `badge-open-${v_id}`,
  badgeOpenPrefix: () => "badge-open-" as TestIdPrefix,
  badgeResolved: (v_id: string) => `badge-resolved-${v_id}`,
  badgeResolvedPrefix: () => "badge-resolved-" as TestIdPrefix,
  linkIdentity: (v_identity_id: string) => `link-identity-${v_identity_id}`,
  linkIdentityPrefix: () => "link-identity-" as TestIdPrefix,
  linkProfile: (v_violatingProfile_id: string) => `link-profile-${v_violatingProfile_id}`,
  linkProfilePrefix: () => "link-profile-" as TestIdPrefix
} as const;
